import { 
    GET_PUBLISHED_EVENTS_PENDING, 
    SET_PUBLISHED_EVENTS, 
    SET_EVENTS_QUESTION, 
    SET_CURRENT_EVENT_ID, 
    SET_QUESTIONS_DATA, 
    SET_UPLOAD_SUCCESS_PENDING, 
    SET_ANSWER_RESPONSE, 
    SET_UPLOAD_RESPONSE, 
    SET_CURRENT_EVENT_NAME, 
    SET_TIMER_BOOLEAN, 
    SET_ACTIVE_QUES_ID,
    SET_IS_GET_PUBLISHED_EVENT_PENDING, 
    SET_IS_GET_QUESTIONS_LIST_PENDING,
    SET_IS_GET_QUESTION_DATA_PENDING,
    SET_IS_SUBMIT_ANSWER_PENDING,
    INIT_AUTOEVAL_DIALOG,
    SET_PROGRESS_VALUE,
    SET_PROGRESS_NAME,
    SET_AUTOEVAL_RESULT_STATUS,
    SET_AUTOEVAL_RESULT_STRING
    
} from "../constants/events.constants";

const initialState: eventsState = {
    publishedEvents: [],
    currentEventId: null,
    questionData: null,
    currentEventName: null,
    uploadPending: false,
    isTimerStarted: false,
    activeQuesId: null,
    isGetPublishedEventsPending: false,
    isGetQuestionsListPending: false,
    isGetQuestionDataPending: false,
    isSubmitAnswerPending: false,
    eventsQuestion: null,
    autoEvalDialogData:{
        progressValue:0,
        currentProgressName:null,
        isTestcasesPassed:false,
        autoEvalResultString:null,
    }
};

export default (
    localState: eventsState = initialState,
    action: Action
): eventsState => {
    switch(action.type)
    {
        case INIT_AUTOEVAL_DIALOG:{
            return{
                ...localState,
                autoEvalDialogData: initialState.autoEvalDialogData,
            }
        }
        case SET_AUTOEVAL_RESULT_STATUS:{
            return{
                ...localState,
                autoEvalDialogData:{
                    ...localState.autoEvalDialogData,
                    isTestcasesPassed: action.payload
                }
            }
        }
        case SET_AUTOEVAL_RESULT_STRING:{
            return{
                ...localState,
                autoEvalDialogData: {
                    ...localState.autoEvalDialogData,
                    autoEvalResultString: action.payload
                }
            }
        }
        case SET_PROGRESS_VALUE: {
            return{
                ...localState,
                autoEvalDialogData:{
                    ...localState.autoEvalDialogData,
                    progressValue: action.payload
                }
            }
        }
        case SET_PROGRESS_NAME:{
            return{
                ...localState,
                autoEvalDialogData:{
                    ...localState.autoEvalDialogData,
                    currentProgressName:action.payload
                }
            }
        }

        case GET_PUBLISHED_EVENTS_PENDING: {
            return {
                ...localState,
                isGetPublishedEventsPending: true,
            };
        }
        case SET_PUBLISHED_EVENTS: {
            return {
                ...localState,
                publishedEvents: action.payload
            }
        }
        case SET_EVENTS_QUESTION: {
            return {
                ...localState,
                eventsQuestion: action.payload
            }
        }

        case SET_ACTIVE_QUES_ID: {
            return{
                ...localState,
                activeQuesId: action.payload
            }
        }

        case SET_CURRENT_EVENT_ID: {
            return {
                ...localState,
                currentEventId: action.payload
            }
        }
        case SET_QUESTIONS_DATA: {
            return {
                ...localState,
                questionData: action.payload
            }
        }
        case SET_ANSWER_RESPONSE: {
            return {
                ...localState,
                answerResponse: action.payload
            }
        }
        case SET_UPLOAD_RESPONSE: {
            return {
                ...localState,
                uploadResponse: action.payload
            }
        }
        case SET_CURRENT_EVENT_NAME: {
            return {
                ...localState,
                currentEventName: action.payload
            }
        }
        case SET_UPLOAD_SUCCESS_PENDING: {
            return {
                ...localState,
                uploadPending: action.payload
            }
        }
        case SET_TIMER_BOOLEAN: {
            return {
                ...localState,
                isTimerStarted: action.payload
            }
        }
        case SET_IS_GET_PUBLISHED_EVENT_PENDING: {
            return {
                ...localState,
                isGetPublishedEventsPending: action.payload
            }
        }
        case SET_IS_GET_QUESTIONS_LIST_PENDING: {
            return {
                ...localState,
                isGetQuestionsListPending: action.payload
            }
        }
        case SET_IS_GET_QUESTION_DATA_PENDING: {
            return {
                ...localState,
                isGetQuestionDataPending: action.payload
            }
        }
        case SET_IS_SUBMIT_ANSWER_PENDING: {
            return {
                ...localState,
                isSubmitAnswerPending: action.payload
            }
        }
        default: {
            return localState;
        }
    }
}